import React from "react";
import TopperGrid from "../section-component/topper-grid/TopperGrid";
import TopperQuotes from "../section-component/topper-quotes/TopperQuotes";
import Navbar from "../../../components/navbar/Navbar";
import Footer from "../../../components/footer/Footer";
import TopperStrategies from "../section-component/topper-strategy/TopperStrategies";
import SubjectWiseFilter from "../section-component/subject-wise/SubjectWiseFilter";
import VideoTestimonials from "../section-component/video-testimonial/VideoTestimonials";
import LiveChat from "../section-component/live-chat/LiveChat";
import SocialMediaPanel from "../../../components/common/social-media/SocialMediaPanel";

const TopperIndex = () => {
    return (
        <>
            
             
            <TopperGrid />
            <TopperQuotes />
            <TopperStrategies />
            <SubjectWiseFilter />
            <VideoTestimonials />

            
        </>
    );
};

export default TopperIndex;